import { InsightsClient } from 'instantsearch.js';

declare global {
  interface Window {
    aa: InsightsClient;
  }
}
import { Button } from '@fagmobler/ui';
import type {
  FagmoblerAlgoliaProduct,
  FagmoblerPublicOmniumProduct,
} from '@fagmobler/types';

import {
  convertLineitemIntoEcommerceObject,
  trackEvent,
} from '@/lib/analytics';

import { useAddItemToCart } from '@/components/cart/useAddItemToCart';
import { useNavigation } from '@/contexts/navigation';
import { useRouter } from 'next/router';
import {
  ALGOLIA_APPLICATION_ID,
  ALGOLIA_INDEX_NAME,
  ALGOLIA_SEARCH_API_KEY,
} from '@/lib/algolia/searchClient';
import { useStores } from '../store';
import { useCart, useUpdateCart } from '@/components/cart';
import { ServerProduct } from '@/lib/janitsjar/Product';

export type AddToCartProps = {
  product: ServerProduct;
  algoliaProduct: FagmoblerAlgoliaProduct;
  selectedVariant?: string;
  children?: React.ReactNode;
  disabled?: boolean;
};

export const AddToCart = ({
  product,
  algoliaProduct,
  selectedVariant,
  children = 'Legg i handlekurv',
  disabled,
}: AddToCartProps) => {
  const addToCart = useAddItemToCart();
  const updateCart = useUpdateCart();
  const { setShowCart } = useNavigation();
  const router = useRouter();
  const { cart } = useCart();

  const { current } = useStores();
  const currentStore = current.data?.store || undefined;

  const handleAddToCart = async () => {
    const line = {
      code: selectedVariant || product.sku,
      quantity: 1,
    };

    setShowCart(true);

    if (!cart.data?.products || cart.data.products.length === 0) {
      await updateCart.mutate({ isMember: true });
    }

    await addToCart.mutate(line);

    trackEvent(
      'add_to_cart',
      convertLineitemIntoEcommerceObject({
        lineItem: line,
        product,
        algoliaProduct,
      }),
      currentStore
    );

    const queryID = router.query.queryID as string;

    if (queryID && window.aa) {
      window.aa('convertedObjectIDsAfterSearch', {
        index: ALGOLIA_INDEX_NAME,
        eventName: 'Add to cart',
        queryID,
        objectIDs: [algoliaProduct.objectID],
      });
    } else {
      if (ALGOLIA_APPLICATION_ID && ALGOLIA_SEARCH_API_KEY && window.aa) {
        window.aa('init', {
          appId: ALGOLIA_APPLICATION_ID,
          apiKey: ALGOLIA_SEARCH_API_KEY,
        });
        window.aa('convertedObjectIDs', {
          index: ALGOLIA_INDEX_NAME,
          eventName: 'Add to cart',
          objectIDs: [algoliaProduct.objectID],
        });
      } else {
        console.error('no window.aa');
      }
    }
  };
  return (
    <div>
      <Button
        variant="add-to-cart"
        className="w-full"
        disabled={disabled}
        onClick={handleAddToCart}
      >
        {children}
      </Button>
    </div>
  );
};

export default AddToCart;
